/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { Link, Redirect } from 'react-router-dom';

import { Button } from './ui/button';
import { Apple, Mail } from 'lucide-react';

import NavBar from './NavBar';
import Card from './Card';
import Store from './Store';
import firebase from 'firebase/app';
import GoogleIcon from './GoogleIcon';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = { appleLoading: false, googleLoading: false };
  }

  handleInvite = async e => {
    // TODO
  };

  onAnonymous = async () => {
    this.setState({
      loading: true,
    });
    try {
      const userCredential = await firebase.auth().signInAnonymously();
      console.log('User signed in anonymously', userCredential.user.uid);
      
      // Wait a moment for Firebase to fully initialize
      await new Promise(resolve => setTimeout(resolve, 100));
      
      // Verify we can get a token
      const token = await userCredential.user.getIdToken();
      console.log('Got Firebase token, length:', token?.length);
      
      this.handleInvite();
      this.setState({ redirectToReferrer: true });
    } catch (e) {
      console.error('Anonymous sign-in error:', e);
      Store.onFailure(e);
      this.setState({ loading: false });
    }
  };

  onApple = async () => {
    this.setState({
      appleLoading: true,
    });
    try {
      var provider = new firebase.auth.OAuthProvider('apple.com');
      await firebase.auth().signInWithPopup(provider);
      console.log('Apple sign-in complete!');
      this.handleInvite();
      this.setState({ redirectToReferrer: true });
    } catch (e) {
      Store.onFailure(e);
    }
  };

  onGoogle = async () => {
    this.setState({
      googleLoading: true,
    });
    try {
      let provider = new firebase.auth.GoogleAuthProvider();

      let userCred = await firebase.auth().signInWithPopup(provider);
      console.log('Google sign-in complete!');
      this.handleInvite();
      this.setState({ redirectToReferrer: true });
    } catch (e) {
      Store.onFailure(e);
    }
  };

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } };
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer) {
      return <Redirect to={from} />;
    }

    return (
      <div className="flex flex-col w-full h-full items-center">
        <NavBar />
        <Card className="p-8 min-w-[500px]">
          <div className="flex mb-4 justify-center">
            <h1 className="text-2xl font-semibold">Welcome to Pushback</h1>
          </div>
          {from && from.pathname !== '/' && (
            <div className="login-warn">
              <p>
                You must log in to view the page at
                <code> {from.pathname}</code>
              </p>
            </div>
          )}
          <div className="flex flex-col justify-center items-center">
            <Button
              variant="secondary"
              className="mt-2 mb-2 w-[250px] bg-black text-white hover:bg-gray-800"
              onClick={this.onApple}
            >
              <Apple className="mr-2 h-4 w-4" />
              Sign in with Apple
            </Button>
            <Button variant="default" className="mt-2 mb-2 w-[250px]" asChild>
              <Link to="/login_with_email">
                <Mail className="mr-2 h-4 w-4" />
                Sign in with Email
              </Link>
            </Button>

            <Button
              variant="default"
              className="mt-2 mb-2 w-[250px]"
              onClick={this.onGoogle}
            >
              <GoogleIcon className="mr-2 h-4 w-4" />
              Sign in with Google
            </Button>
            <Button
              variant="default"
              className="mt-2 mb-2 w-[250px]"
              onClick={this.onAnonymous}
            >
              Try it out, sign up later
            </Button>
          </div>
        </Card>
      </div>
    );
  }
}

export default Login;
